import React from "react";
import styled from "styled-components";

const FooterLinkItemWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 10px;
  margin-right: 100px;
`;

function FooterLinkItem({ children, href }: IFooterLinkItem) {
    return (
        <FooterLinkItemWrapper>
            <a
                href={href}
                style={{
                    color: "#7A7C8B",
                    fontSize: "14px",
                    letterSpacing: `-0.01em`,
                }}
            >
                {children}
            </a>
        </FooterLinkItemWrapper>
    );
}

export interface IFooterLinkItem {
    children: React.ReactChild;
    href: string;
}

export default FooterLinkItem;
